import React from 'react';
import PropTypes from 'prop-types';
import Navbar from './Navbar'
import Footer from './Footer'
import ScrollUp from './ScrollUp.js'

function Template({children}) {
  return (
    <>
      <Navbar />
      <div className="row body">
        {children}
      </div>
      <Footer />
      <ScrollUp/>
    </>
  )
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Template;